import { render, staticRenderFns } from "./LeiBieList.vue?vue&type=template&id=1cc75674&scoped=true"
import script from "./LeiBieList.vue?vue&type=script&lang=js"
export * from "./LeiBieList.vue?vue&type=script&lang=js"
import style0 from "./LeiBieList.vue?vue&type=style&index=0&id=1cc75674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc75674",
  null
  
)

export default component.exports